// extracted by mini-css-extract-plugin
export var cta = "CtaSection-module--cta--97420";
export var ctaButton = "CtaSection-module--ctaButton--d4ef6";
export var ctaGroup = "CtaSection-module--ctaGroup--6868c";
export var ctaTitle = "CtaSection-module--ctaTitle--5b780";
export var ctaWrapper = "CtaSection-module--ctaWrapper--794d6";